'use strict';

module.exports = 2147483647;



//////////////////
// WEBPACK FOOTER
// ./~/timers-ext/max-timeout.js
// module id = 627
// module chunks = 4